import axios from "./axiosInstance";

const BigTripsAPI = {
  getBigTrips: () => axios.get(`/bigtrips`),
};

export default BigTripsAPI;